export interface CableSizingStandard {
    code: number;
    label: string;
    name: string;
    calculationType: number;
    icon: string;
    badgeLabel: string;
    badgeColor: string;
}

export const CABLE_SIZING_STANDARDS: CableSizingStandard[] = [
    { code: 0, label: 'AS', name: 'AS/NZS 3008.1.1 (Australian)', calculationType: 1, icon: 'assets/cablepro/img/AScalc.png', badgeLabel: 'AS/NZS 3008.1.1', badgeColor: '#D38B1F' },
    { code: 1, label: 'NZ', name: 'AS/NZS 3008.1.2 (New Zealand)', calculationType: 13, icon: 'assets/cablepro/img/NZScalc.png', badgeLabel: 'AS/NZS 3008.1.2', badgeColor: '#2693A8' },
    { code: 2, label: 'BS', name: 'BS 7671 (British)', calculationType: 3, icon: 'assets/cablepro/img/BScalc.png', badgeLabel: 'BS 7671', badgeColor: '#D62828' },
    { code: 3, label: 'IEC', name: 'IEC 60364-5-52 (International)', calculationType: 9, icon: 'assets/cablepro/img/IECcalc.png', badgeLabel: 'IEC 60364-5-52', badgeColor: '#2B61A3' },
    { code: 4, label: 'NEC', name: 'NEC NFPA 70 (United States)', calculationType: 12, icon: 'assets/cablepro/img/NECcalc.png', badgeLabel: 'NFPA 70 (NEC)', badgeColor: '#D85B2A' },
];

export function cableSizingStandardBadgeByType(calculationType: number): Pick<CableSizingStandard, 'badgeLabel' | 'badgeColor'> | undefined {
    const standard = CABLE_SIZING_STANDARDS.find(s => s.calculationType === calculationType);
    return standard ? { badgeLabel: standard.badgeLabel, badgeColor: standard.badgeColor } : undefined;
}

export function cableSizingStandardIconByType(calculationType: number): string {
    return CABLE_SIZING_STANDARDS.find(s => s.calculationType === calculationType)?.icon
        ?? 'assets/cablepro/img/calc.png';
}

export function standardNameLabel(name: string): string {
    return name.replace(/\s*\([^)]*\)\s*$/, '');
}

export function standardNameRegion(name: string): string {
    return name.match(/\([^)]*\)\s*$/)?.[0] ?? '';
}
